import { render } from "./Diagnostic.vue?vue&type=template&id=35dc29d2&scoped=true"
import script from "./Diagnostic.vue?vue&type=script&setup=true&lang=js"
export * from "./Diagnostic.vue?vue&type=script&setup=true&lang=js"

import "./Diagnostic.vue?vue&type=style&index=0&id=35dc29d2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35dc29d2"],['__file',"src/pages/common/Diagnostic.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35dc29d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35dc29d2', __exports__)) {
    console.log('reload')
    api.reload('35dc29d2', __exports__)
  }
  
  module.hot.accept("./Diagnostic.vue?vue&type=template&id=35dc29d2&scoped=true", () => {
    console.log('re-render')
    api.rerender('35dc29d2', render)
  })

}


export default __exports__